import { HttpService } from '@src/api/common/HttpService';
import { UrlService } from '@src/api/common/UrlService';
import { CteApiUrl } from '@src/constants/BaseUrls';

type RoleType = {
  id: number | string;
};

export const FollowUpStatusService = () => {
  const { HttpGet, HttpPost, HttpDelete } = HttpService();

  const GetAll = async (body: any) => {
    const suffix =
      typeof body === 'string' ? body : UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/follow-up-status${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

  const GetById = async (body: RoleType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/follow-up-status/detail${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

  const CreateOrUpdateItem = async (body: any) => {
    const url = `${CteApiUrl}/api/v1/follow-up-status/detail`;
    const response = await HttpPost(url, body);
    return response;
  };

  const LogicDeleteById = async (body: RoleType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/follow-up-status/detail${suffix}`;
    const response = await HttpDelete(url);
    return response;
  };

  return {
    GetAll,
    GetById,
    CreateOrUpdateItem,
    LogicDeleteById,
  };
};
